import { render, staticRenderFns } from "./TheSystemMessage.vue?vue&type=template&id=252b4104"
import script from "./TheSystemMessage.vue?vue&type=script&lang=js"
export * from "./TheSystemMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports